module.exports = __webpack_public_path__ + "img/awo.7b7a1880.svg";